// function generatingLayerId(type: string, id: any, isForDrawing: boolean = false) {
//   const sourceId = `${type}#${id}`;
//   const layerId = `${type}#${id}-layer`;
//   return { sourceId, layerId };
// }

// export { generatingLayerId };



/**
 * Generate unique source & layer IDs for Mapbox, optionally tagging
 * them for “draw” mode by prefixing "draw-".
 *
 * @param type           The feature type (e.g. "shape" or "region")
 * @param id             The unique item ID
 * @param isForDrawing   If true, prefixes "draw-" to both IDs
 */
export function generatingLayerId(
  type: string,
  id: string | number,
  isForDrawing: boolean = false
) {
  const prefix = isForDrawing ? 'drawn-' : '';

  const sourceId = `${prefix}${type}#${id}`;
  const layerId = `${prefix}${type}#${id}-layer`;

  return { sourceId, layerId };
}
